import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FilesService } from 'src/app/core/services/files.service';
import { specialCategory } from 'src/app/modules/cases/components/create-case/ras-form/ras-form.utils';
import { instruments } from '../utils/instrumentTypes';
import { operationTypes } from '../utils/operationTypes';
import { riskCategorys } from '../utils/riskCategorys';

enum Texts {
  amount = 'Monto de la(s) operación(es) ',
  credit = 'Credito(s): que representen abono, ingreso o incremento',
  debit = 'Débito(s): Retiro, egreso o disminuición',
  description = 'Descripción de la actividad realizada *',
  descriptionHint = 'De considerarlo necesario, podrá anexar, informe que complemente el análisis, ampliando la información sobre la actividad desarrollada y otros datos, como cuadros estadisticos, gráficos, entre otros.',
  otherPerson = 'Otras personas relacionadas en el reporte',
  category = 'Categoría especial de Riesgo',
  file = 'Informe Complementario',
  title = 'Otros instrumentos o productos vinculados al cliente',
  instrumentType = 'Tipo de instrumento o producto',
  instrumentNumber = 'Número del instrumento o producto',
  agency = 'Agencia de apertura',
  openingDate = 'Fecha de apertura',
  deadline = 'Fecha de cierre',
}
@Component({
  selector: 'app-description-ras',
  templateUrl: './description-ras.component.html',
  styleUrls: ['./description-ras.component.scss'],
})
export class DescriptionRasComponent implements OnInit {
  public Texts = Texts;

  @Input() data: { task: any };

  constructor(
    private readonly fb: FormBuilder,
    public filesService: FilesService
  ) {}
  specialCategory = specialCategory;
  riskCategorys = riskCategorys;
  instrumentsT = instruments;
  form: FormGroup = this.fb.group({
    reportType: ['', [Validators.required]],
    typeDate: ['', [Validators.required]],
    date: [''],
    operationRef: [''],
    from: [''],
    to: [''],
    currency: ['', [Validators.required]],
    typeOfCurrency: ['', Validators.required],
    credit: [0],
    debit: [0],
    description: ['', [Validators.required]],
    file: [''],
    otherPerson: [],
    operationType: ['', [Validators.required]],
    // instrumentDescription: this.fb.group({
    instrumentType: [''],
    instrumentNumber: [''],
    agency: [''],
    openingDate: [''],
    deadline: [''],
    // }),
    othersInstruments: [],
    category: ['', [Validators.required]],
    check: [false, [Validators.required]], //este verifica si se trata de otro tipo de operacion
    // otherPerson: [data?.otherPerson || ''],
  });

  operationTypes = operationTypes;
  file;
  fileName;
  addFile() {
    const input = document.createElement('input');
    input.type = 'file';
    input.click();
    input.onchange = (ev: any) => {
      const file: File = ev.target.files[0];
      const formData = new FormData();
      formData.append('file', file);
      this.filesService.upload(formData).subscribe({
        next: (url) => {
          const newFile = {
            url,
            name: file.name,
          };
          // this.instrumentForm.value.file = newFile
          this.form.get('file').setValue(newFile);
          this.file = newFile;
          this.form.value.file = newFile;
          // this.filesChange.emit(this.files);
          // if (this.isEditing) {
          //   this.newFiles.push(newFile);
          //   this.newFilesChange.emit(this.newFiles);
          // }
        },
      });
    };
  }
  download() {
    const path = this.file.url + `?name=${this.file.name}&download=true`;
    var a = document.createElement('a');
    a.href = path;
    a.download = path.substr(path.lastIndexOf('/') + 1);
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  deleteFile() {
    this.form.get('file').setValue(undefined);
    this.file = undefined;
  }
  ngOnInit() {
    // this.form.controls['file'].disable();
    const { task } = this.data;
    const values = task.data;
    console.log(values);
    if (values) {
      this.form.patchValue(values);
      if (values.file) {
        this.file = values.file;
        this.form.get('file').setValue(values.file.name);
      }
    }
  }
}
